import {MeterData} from './shared/components/chart/meterData';

const meterDataConst: MeterData = {
    loadedPortfolioID: "",
    startTime: new Date(2000, 1, 1, 0, 0, 0),
    endTime: new Date(2000, 1, 1, 23, 59),
    level: 'REGISTRATION',
    dataLoadTimestamp: 0,
    product:'econ-dr',
    dataSeries: [
        {
            label: "Every 5 minutes",
            collatedSeries: [],
            intervals: [new Date(2000, 1, 1, 1, 0), new Date(2000, 1, 1, 1, 5), new Date(2000, 1, 1, 1, 10), new Date(2000, 1, 1, 1, 15), new Date(2000, 1, 1, 1, 20), new Date(2000, 1, 1, 1, 25), new Date(2000, 1, 1, 1, 30), new Date(2000, 1, 1, 1, 35), new Date(2000, 1, 1, 1, 40), new Date(2000, 1, 1, 1, 45), new Date(2000, 1, 1, 1, 50), new Date(2000, 1, 1, 1, 55), new Date(2000, 1, 1, 2, 0), new Date(2000, 1, 1, 2, 5), new Date(2000, 1, 1, 2, 10), new Date(2000, 1, 1, 2, 15), new Date(2000, 1, 1, 2, 20), new Date(2000, 1, 1, 2, 25), new Date(2000, 1, 1, 2, 30), new Date(2000, 1, 1, 2, 35), new Date(2000, 1, 1, 2, 40), new Date(2000, 1, 1, 2, 45), new Date(2000, 1, 1, 2, 50), new Date(2000, 1, 1, 2, 55)],
            stepped: false,
            colour: "black",
            datalines: [
                {
                    id: "1",
                    dataValues: [15400, 25410, 25420, 25430, 25440, 25450, 25450, 25460, 25500, 25440, 25500, 26500, 27510, 28520, 29300, 25400, 25600, 25700, 25800, 25200, 25300, 25500, 25600, 25555]
                },
                {
                    id: "2",
                    dataValues: [18500, 37510, 37520, 37530, 37540, 37550, 37550, 37560, 37600, 37540, 37600, 37600, 37610, 37620, 37400, 37500, 37700, 37800, 37900, 27230, 37500, 37700, 37800, 37955]
                }
            ]
        },
        {
            label: "Every 15 minutes",
            collatedSeries: [],
            intervals: [new Date(2000, 1, 1, 1, 0), new Date(2000, 1, 1, 1, 15), new Date(2000, 1, 1, 1, 30), new Date(2000, 1, 1, 1, 45), new Date(2000, 1, 1, 2, 0), new Date(2000, 1, 1, 2, 15), new Date(2000, 1, 1, 2, 30), new Date(2000, 1, 1, 2, 45), new Date(2000, 1, 1, 3, 0), new Date(2000, 1, 1, 3, 15), new Date(2000, 1, 1, 3, 30), new Date(2000, 1, 1, 3, 45), new Date(2000, 1, 1, 4, 0), new Date(2000, 1, 1, 4, 15), new Date(2000, 1, 1, 4, 30), new Date(2000, 1, 1, 4, 45), new Date(2000, 1, 1, 5, 0), new Date(2000, 1, 1, 5, 15), new Date(2000, 1, 1, 5, 30), new Date(2000, 1, 1, 5, 45), new Date(2000, 1, 1, 6, 0), new Date(2000, 1, 1, 6, 15), new Date(2000, 1, 1, 6, 30), new Date(2000, 1, 1, 6, 45)],
            stepped: false,
            colour: "blue",
            datalines: [
                {
                    id: "1",
                    dataValues: [15400, 25410, 25420, 25430, 25440, 25450, 25450, 25460, 25500, 25440, 25500, 26500, 27510, 28520, 29300, 25400, 25600, 25700, 25800, 25200, 25300, 25500, 25600, 25555]
                },
                {
                    id: "2",
                    dataValues: [18500, 37510, 37520, 37530, 37540, 37550, 37550, 37560, 37600, 37540, 37600, 37600, 37610, 37620, 37400, 37500, 37700, 37800, 37900, 27230, 37500, 37700, 37800, 37955]
                }
            ]
        }]
};

export function GetData(): MeterData {    
    return meterDataConst;
  }



// WEBPACK FOOTER //
// ./src/app/meter-usage-mock-data.ts